import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import './AuditList.css'
import share from "./share.png";
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Support from '../contact-popup-module/Support'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions'
import { useSwipeable } from 'react-swipeable'
import { saveAs } from 'file-saver'
import Claim from './Claim';
const AuditList = () => {
  const downloadIcon = `${process.env.PUBLIC_URL}/custom-icons/download.svg`
  const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`
  const menuIcon = `${process.env.PUBLIC_URL}/custom-icons/menu-icon.png`
  const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`
  const searchIcon = `${process.env.PUBLIC_URL}/custom-icons/search.svg`
  const next = `${process.env.PUBLIC_URL}/custom-icons/next-arrow.png`
  const upArrow = `${process.env.PUBLIC_URL}/custom-icons/upArrow.svg`
  const downArrow = `${process.env.PUBLIC_URL}/custom-icons/downArrow.svg`
  const location = useLocation()
  const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))

  const userID = location.state?.userId || insuranceUser?.userId

  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'new')
  const [currentFilter, setCurrentFilter] = useState('all')
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const popupRef = useRef(null)
  const navigate = useNavigate()
  const [audits, setAudits] = useState([])
  const [agentDetails, setAgentDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [open, setOpen] = useState(false)
  const [openSharePopup, setOpenSharePopup] = useState(false)
  const [selectedAuditUrl, setSelectedAuditUrl] = useState('')
  const [dialogWidth, setDialogWidth] = useState('29vw')
  const [isAscending, setIsAscending] = useState(false)
  const [audit_status, setAuditStatus] = useState(null)
  const [formDetailsMap, setFormDetailsMap] = useState({})
  const [allInfoLoaded, setAllInfoLoaded] = useState(false)
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [counts, setCounts] = useState({ new: 0, inProgress: 0, inactive: 0, claim: 0 })
  const [sortedAudits, setSortedAudits] = useState([])
  
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab)
    }
  }, [location.state])

  useEffect(() => {
    const fetchAuditsAndDetails = async () => {
      setLoading(true);

      try {
        if (!userID) {
          console.error('User ID is missing');
          setLoading(false);
          return;
        }

        const [auditResponse, agentResponse] = await Promise.all([
          axios.post('/agentApis/getAgentAllAuditInfo', { userID }),
          axios.post('/agentApis/getCompleteAgentInfo', { userID })
        ]);

        console.log('Audits by user:', auditResponse.data, agentResponse.data);

        // Map initial audit data - ALL audits go to 'new' status (Endorsements)
        let auditData = auditResponse.data
         .filter(item => item.used !== "expired") 
        .map(item => {
          const leadTime = item.lead_creation_time || '';
          const [date = '--', time = '--'] = leadTime.split(' ');

          return {
            id: item.audit,
            date,
            time,
            used: item.used,
            status: 'new', 
            type: ['Inspection'],
            mode: item.audit_mode,
              originalUsedStatus: item.used 
          };
        });

        console.log("Initial auditData length:", auditData.length);

        // Batch fetch audit details
        const auditIds = auditData.map(audit => audit.id);
        console.log("Total audits to fetch details for:", auditIds.length);

        const startTime = performance.now();

        const detailsResponse = await axios.post('/process_data/batch_check_and_get_details', {
          auditIds
        });

        const endTime = performance.now();
        console.log(`Time taken to fetch batch details: ${(endTime - startTime).toFixed(2)} ms`);

        const fetchedDetails = detailsResponse.data.audits;

        // Merge fetched details with auditData
        const auditDataWithDetails = auditData.map(audit => {
          const found = fetchedDetails.find(item => item.id === audit.id);
          return {
            ...audit,
            Make: found?.details.Make || '',
            Model: found?.details.Model || '',
            'Name of Customer': found?.details["Farmer's Name"] || ' ',
            'Address': found?.details["Farmer's Address"] || ' '
          };
        });

        console.log("auditDataWithDetails:", auditDataWithDetails);

        // Compute status counts - all audits in 'new' status
        const computedCounts = {
          new: auditDataWithDetails.length,
          inProgress: 0,
          inactive: 0
        };

        console.log("Computed counts:", computedCounts);

        // Update state
        setAudits(auditDataWithDetails);
        setCounts(computedCounts);

        if (agentResponse.status === 200) {
          setAgentDetails(agentResponse.data[0]);
        } else {
          setError('Failed to fetch agent details');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('An error occurred while fetching data');
      } finally {
        setLoadingComplete(true);
        setLoading(false);
      }
    };

    fetchAuditsAndDetails();
  }, [userID]);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth <= 450) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 475) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogWidth('64vw')
      } else if (windowWidth <= 650) {
        setDialogWidth('60vw')
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth('57vw')
      } else if (window.innerWidth <= 875) {
        setDialogWidth('55vw')
      } else if (windowWidth <= 1000) {
        setDialogWidth('48vw')
      } else if (window.innerWidth <= 1100) {
        setDialogWidth('45vw')
      } else if (windowWidth <= 1300) {
        setDialogWidth('40vw')
      } else {
        setDialogWidth('35vw')
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])


 
  const tabsRef = useRef({})

  const handleTabClick = tab => {
    // Only allow clicking on 'new' tab, disable 'inactive' tab
    if (tab === 'inactive') return;
    
    setActiveTab(tab)

    tabsRef.current[tab]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    })
  }
// Function to check if start button should be shown
// const shouldShowStartButton = (audit) => {
//   const disabledStatuses = ['processed', 'processing', 'expired'];
//   return !disabledStatuses.includes(audit.originalUsedStatus || audit.used);
// };

// // Function to get button text based on status
// const getButtonText = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   const statusConfig = {
//     'processed': 'Completed',
//     'processing': 'In Progress',
//     'expired': 'Expired'
//   };
//   return statusConfig[status] || 'Start';
// };

// // Function to check if button should be disabled
// const isButtonDisabled = (audit) => {
//   return !shouldShowStartButton(audit);
// };
// Function to check if button should be shown
// const shouldShowButton = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   const hiddenStatuses = ['processed', 'processing', 'expired'];
//   return !hiddenStatuses.includes(status);
// };
// Function to check if button should be shown
// const shouldShowButton = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   const hiddenStatuses = ['processed', 'processing', 'expired'];
//   return !hiddenStatuses.includes(status);
// };
const getButtonLabel = (audit) => {
  const status = audit.used;
  if (status === "processed") return "More Info";
  return "Start"; // accessed/created/others
};
const handleNavigateClick = (audit) => {
  if (audit.used === "processed") {
    navigate(`/AuditDesc/${audit.id}`, {
        state: { audit, userID, agentDetails, activeTab }
    });
   // ✅ your required route
  } else {
    navigate(`/auditDescription`, {
      state: { audit, userID, agentDetails, activeTab }
    });
  } 
};
// Function to get button text based on status


// Function to check if button should be disabled (only for 'accessed')
// const isButtonDisabled = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   return status === 'accessed';
// };


  const tabs = ['new', 'renewal', 'claim']

  const [swiping, setSwiping] = useState(false)

  const swipeHandlers = useSwipeable({
    onSwiping: () => setSwiping(true),
    onSwiped: () => setSwiping(false),
    // onSwipedLeft: () => {
    //   // Disable swipe to claim tab
    //   const currentIndex = tabs.indexOf(activeTab)
    //   if (currentIndex < tabs.length - 1 && tabs[currentIndex + 1] !== 'claim') {
    //     handleTabClick(tabs[currentIndex + 1])
    //   }
    // },
    onSwipedLeft: () => {
  const currentIndex = tabs.indexOf(activeTab);
  if (currentIndex < tabs.length - 1 && tabs[currentIndex + 1] !== 'inactive') {
    handleTabClick(tabs[currentIndex + 1]);
        }
      },

    onSwipedRight: () => {
      const currentIndex = tabs.indexOf(activeTab)
      if (currentIndex > 0) {
        handleTabClick(tabs[currentIndex - 1])
      }
    },
    delta: 80,
    trackTouch: true,
    preventScrollOnSwipe: true
  })



  const handleClickOutside = event => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsPopupVisible(false)
    }
  }

  useEffect(() => {
    if (isPopupVisible) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isPopupVisible])
  
  // const handleNavigateClick = audit => {
  //   console.log(userID)
  //   navigate(`/auditDescription`, {
  //     state: { audit, userID, agentDetails, activeTab }
  //   })
  // }
  
 
const handleAddClick = async () => {
  try {
    console.log('Checking audit limit for userID:', userID);

    // Check audit limit before navigating
    const response = await axios.post('/create_audit/check_audit_limit', {
      userID: userID
    });

    console.log('Audit limit response:', response.data);

    // ✅ FIXED: Check if limit is reached
    if (response.data.success && response.data.hasReachedLimit) {
      toast.error("You can't create audit now, you have reached the limit", {
        position: 'bottom-center',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'custom-toast',
        style: {
          background: '#fff',
          color: '#FC350B',
          fontWeight: 'bold',
          border: '2px solid #FC350B'
        }
      });
      return; // ✅ STOP HERE - Don't navigate
    }

    // If limit not reached, navigate to home
    navigate('/home');
    
  } catch (error) {
    console.error('Error checking audit limit:', error);
    
    // ✅ FIXED: Don't navigate on error - fail closed
    toast.error('Failed to verify audit limit. Please try again.', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      className: 'custom-toast',
      style: {
        background: '#fff',
        color: '#FC350B',
        fontWeight: 'bold',
        border: '2px solid #FC350B'
      }
    });
    // Don't navigate - return here
  }
};
const handleAddClick2 = async () => {
  try {
    console.log('Checking audit limit for userID:', userID);

    // Check audit limit before navigating
    const response = await axios.post('/create_audit/check_audit_limit2', {
      userID: userID
    });

    console.log('Audit limit response:', response.data);

    // ✅ FIXED: Check if limit is reached
    if (response.data.success && response.data.hasReachedLimit) {
      toast.error("You can't create audit now, you have reached the limit", {
        position: 'bottom-center',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'custom-toast',
        style: {
          background: '#fff',
          color: '#FC350B',
          fontWeight: 'bold',
          border: '2px solid #FC350B'
        }
      });
      return; // ✅ STOP HERE - Don't navigate
    }

    // If limit not reached, navigate to home
    navigate('/ClaimNewAudit');
    
  } catch (error) {
    console.error('Error checking audit limit:', error);
    
    // ✅ FIXED: Don't navigate on error - fail closed
    toast.error('Failed to verify audit limit. Please try again.', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      className: 'custom-toast',
      style: {
        background: '#fff',
        color: '#FC350B',
        fontWeight: 'bold',
        border: '2px solid #FC350B'
      }
    });
    // Don't navigate - return here
  }
};
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  
  const handleLogout = () => {
    navigate('/login')
  }
 



  const [filteredAudit, setFilteredAudit] = useState([])
  const filteredAudits = (
    filteredAudit.length > 0 ? filteredAudit : audits
  ).filter(audit => {
    return audit.status === activeTab
  })

  const handleSearch = query => {
    const filtered = audits.filter(
      audit =>
        audit['Name of Customer'].toLowerCase().includes(query.toLowerCase()) ||
        audit['id'].toLowerCase().includes(query.toLowerCase())
    )
    setFilteredAudit(filtered)
  }

  const [sortOrder, setSortOrder] = useState('desc')

  const handleDateSort = () => {
    setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'))
  }
  
  console.log('activeTab', activeTab)

  return (
    <div className='audit-list-container'>
      <div className='header-container'>
        <h1>Assigned Cattle Insurance</h1>
        <img
          src={menuIcon}
          alt='Options'
          className='three-dots-icon'
          onClick={() => setIsPopupVisible(!isPopupVisible)}
        />
        {isPopupVisible && (
          <div className='popup-menu' ref={popupRef}>
            <button className='popup-item' onClick={handleClickOpen}>
              <img src={infoIcon} alt='Info' className='info-icon' />
              Help
            </button>
            <button className='popup-item' onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
      
      <Dialog
        open={open}
        onClose={handleClose}
        className='support-popup-dialog'
      >
        <DialogContent className='support-popup-content'>
          <Support />
          <button onClick={handleClose} className='close-btn'>
            close
          </button>
        </DialogContent>
      </Dialog>

      <div className='tabs-container'>
        <div className='tabs'>
          <button
            className={activeTab === 'new' ? 'active' : ''}
            onClick={() => handleTabClick('new')}
            ref={el => (tabsRef.current['new'] = el)}
          >
            New Insurance <span className='count'>{counts.new}</span>
          </button>
          <button
            className={`${activeTab === 'inactive' ? 'active' : ''} inactive-tab`}
            onClick={() => handleTabClick('inactive')}
            ref={el => (tabsRef.current['inactive'] = el)}
            disabled
            style={{
              opacity: 0.5,
              cursor: 'not-allowed',
              pointerEvents: 'none'
            }}
          >
            Renewal <span className='count'>{counts.new}</span>
          </button>
          <button
            className={activeTab === 'claim' ? 'active' : ''}
            onClick={() => handleTabClick('claim')}
            ref={el => (tabsRef.current['claim'] = el)}
          >
            Claim <span className='count'>{counts.claim}</span>
          </button>
        </div>
      </div>

      {/* Claim tab content is rendered from separate component */}
      {activeTab === 'claim' && <Claim userID={userID} activeTab={activeTab} onCountUpdate={(count) => setCounts(prev => ({ ...prev, claim: count }))} />}

      {/* For non-claim tabs, show the search bar above the audit list */}
      {activeTab !== 'claim' && (
        <div className='filters'>
          <div className='search-container'>
            <input
              type='text'
              placeholder='Search'
              className='search-input'
              onChange={e => handleSearch(e.target.value)}
            />
            <img src={searchIcon} alt='Search Icon' className='search-icon' />
          </div>
          {/* {!(activeTab === 'new' || activeTab === 'inProgress') && (
            <button className='date-filter-button' onClick={handleDateSort}>
              Date
              <span className='sort-icon'>
                <img
                  src={downArrow}
                  alt='Sort Descending'
                  className={`sort-arrow down-arrow ${sortOrder === 'desc' ? 'visible' : 'hidden'}`}
                />
                <img
                  src={upArrow}
                  alt='Sort Ascending'
                  className={`sort-arrow up-arrow ${sortOrder === 'asc' ? 'visible' : 'hidden'}`}
                />
              </span>
            </button>
          )} */}
        </div>
      )}

      {!loadingComplete ? (
        <div className='loader-container'>
          <CircularProgress style={{ color: '#FC350B' }} size={40} />
        </div>
      ) : audits.length === 0 ? (
        <div className='no-audit-message'>
        </div>
      ) : (
        <div
          {...swipeHandlers}
          className={`audit-cards ${swiping ? 'swiping' : ''}`}
        >
          {
            filteredAudits
              .slice()
              .sort((a, b) => {
                const dateA = moment(
                  `${a.date} ${a.time}`,
                  'DD-MM-YYYY HH:mm'
                ).toDate()
                const dateB = moment(
                  `${b.date} ${b.time}`,
                  'DD-MM-YYYY HH:mm'
                ).toDate()

                return sortOrder === 'asc' ? dateA - dateB : dateB - dateA
              })
              .map(audit => (
                <div className='audit-card' key={audit.id}>
                  <div className='audit-header'>
                    <div className='header-one'>
                      <p className='audit-id'>{audit.id}</p>
                      <div className='date-container'>
                        <img
                          src={calendar}
                          alt='Calendar Icon'
                          className='calendar-icon'
                        />
                        <p>{audit.date}</p>
                      </div>
                    </div>
                    <div className='header-two'>
                      <div className='audit-tags'>
                        {audit.mode && (
                          <span className='audit-tag'>
                            {audit.mode.charAt(0).toUpperCase() +
                              audit.mode.slice(1).toLowerCase()}
                            Mode
                          </span>
                        )}
                      </div>

                      <p>{audit.time}</p>
                    </div>
                  </div>
                  {/* <div className='audit-details'>
                    <p>
                     Name: {audit['Name of Customer'] || ''}
                    </p>
                    <p>Address : {audit['Address'] || ''}</p>
                  </div> */}

                  {/* <div className='audit-actions'> */}
                    {/* {activeTab === 'inactive' ? (
                      audit.used === 'processed' ? (
                        <button
                          className='download-button'
                          onClick={() => handleDownloadClick(audit.id)}
                          disabled={downloading[audit.id]}
                        >
                          {downloading[audit.id]
                            ? 'Downloading...'
                            : 'Download'}
                          <img
                            src={downloadIcon}
                            alt='Download Icon'
                            className='download-icon'
                          />
                        </button>
                      ) : audit.used === 'processing' ? (
                        <button className='expired-button' disabled>
                          Used
                        </button>
                      ) : (
                        <button className='expired-button' disabled>
                          Expired
                        </button>
                      )
                    ) : (
                      <button
                        className='share-button'
                        onClick={() => handleShareClick(audit)}
                      >
                        <img
                          src={share}
                          alt='Share Icon'
                          className='share-icon'
                        />
                        Share
                      </button>
                    )} */}

                    {/* <button
                      className='navigate-button'
                      onClick={() => handleNavigateClick(audit)}
                    >
                      {activeTab === 'inactive' ? 'More Info' : 'Start'}
                      <img src={next} alt='next Icon' className='next-icon' />
                    </button> */}
{/* <div className='audit-actions'>
  {shouldShowButton(audit) && (
    <button
      className={`navigate-button ${isButtonDisabled(audit) ? 'disabled-button' : ''}`}
      onClick={() => handleNavigateClick(audit)}
      disabled={isButtonDisabled(audit)}
    >
      {getButtonText(audit)}
      <img src={next} alt='next Icon' className='next-icon' />
    </button>
  )}
</div> */}
{/* <div className='audit-actions'>
  {shouldShowButton(audit) && (
    <button
      className='navigate-button'
      onClick={() => handleNavigateClick(audit)}
    >
      Start
      <img src={next} alt='next Icon' className='next-icon' />
    </button>
  )}
</div> */}
<div className='audit-actions'>
  <button className='navigate-button' onClick={() => handleNavigateClick(audit)}>
    {getButtonLabel(audit)}
    <img src={next} alt='next Icon' className='next-icon' />
  </button>
</div>

                    {/* <button
  className={`navigate-button ${isButtonDisabled(audit) ? 'disabled-button' : ''}`}
  onClick={() => handleNavigateClick(audit)}
  disabled={isButtonDisabled(audit)}
>
  {getButtonText(audit)}
  <img src={next} alt='next Icon' className='next-icon' />
</button> */}
                  {/* </div> */}
                </div>
              ))
          }
        </div>
      )}
      {activeTab === 'new' && (
        <button className='fab' onClick={() => handleAddClick()}>
          +
        </button>
      )}
      
       {activeTab === 'claim' && (
        <button className='fab' onClick={() => handleAddClick2()}>
          +
        </button>
      )}
      
    </div>
  )
}

export default AuditList;


// import './AuditList.css'
// import share from "./share.png";
// import { useNavigate, useLocation } from 'react-router-dom'
// import axios from 'axios'
// import { ToastContainer, toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
// import Support from '../contact-popup-module/Support'
// import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
// import CircularProgress from '@material-ui/core/CircularProgress'
// import moment from 'moment'
// import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions'
// import { useSwipeable } from 'react-swipeable'
// import { saveAs } from 'file-saver'

// const AuditList = () => {
//   const downloadIcon = `${process.env.PUBLIC_URL}/custom-icons/download.svg`
//   const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`
//   const menuIcon = `${process.env.PUBLIC_URL}/custom-icons/menu-icon.png`
//   const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`
//   const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`
//   const searchIcon = `${process.env.PUBLIC_URL}/custom-icons/search.svg`
//   const next = `${process.env.PUBLIC_URL}/custom-icons/next-arrow.png`
//   const upArrow = `${process.env.PUBLIC_URL}/custom-icons/upArrow.svg`
//   const downArrow = `${process.env.PUBLIC_URL}/custom-icons/downArrow.svg`

//   const location = useLocation()
//   const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))
//   const userID = location.state ? location.state.userId : insuranceUser?.userId
//   const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'new')
//   const [currentFilter, setCurrentFilter] = useState('all')
//   const [isPopupVisible, setIsPopupVisible] = useState(false)
//   const popupRef = useRef(null)
//   const navigate = useNavigate()
//   const [audits, setAudits] = useState([])
//   const [agentDetails, setAgentDetails] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [open, setOpen] = useState(false)
//   const [openSharePopup, setOpenSharePopup] = useState(false)
//   const [selectedAuditUrl, setSelectedAuditUrl] = useState('')
//   const [dialogWidth, setDialogWidth] = useState('29vw')

//   const [isAscending, setIsAscending] = useState(false)

//   const [audit_status, setAuditStatus] = useState(null)
//   const [formDetailsMap, setFormDetailsMap] = useState({})
//   const [allInfoLoaded, setAllInfoLoaded] = useState(false)
//   const [loadingComplete, setLoadingComplete] = useState(false)
//   const [counts, setCounts] = useState({ new: 0, inProgress: 0, inactive: 0 })
//   const [sortedAudits, setSortedAudits] = useState([])
  
//   useEffect(() => {
//     if (location.state?.activeTab) {
//       setActiveTab(location.state.activeTab)
//     }
//   }, [location.state])

//   useEffect(() => {
//     const fetchAuditsAndDetails = async () => {
//       setLoading(true);

//       try {
//         if (!userID) {
//           console.error('User ID is missing');
//           setLoading(false);
//           return;
//         }

//         const [auditResponse, agentResponse] = await Promise.all([
//           axios.post('/agentApis/getAgentAllAuditInfo', { userID }),
//           axios.post('/agentApis/getCompleteAgentInfo', { userID })
//         ]);

//         console.log('Audits by user:', auditResponse.data, agentResponse.data);

//         // Map initial audit data - ALL audits go to 'new' status (Endorsements)
//         let auditData = auditResponse.data.map(item => {
//           const leadTime = item.lead_creation_time || '';
//           const [date = '--', time = '--'] = leadTime.split(' ');

//           return {
//             id: item.audit,
//             originalId: item.audit, // Keep original audit ID
//             date,
//             time,
//             used: item.used,
//             status: 'new', // All audits are now shown in Endorsements tab
//             type: ['Inspection'],
//             mode: item.audit_mode,
//             no_of_cattles: item.no_of_cattles || 1 // Store the number of cattles
//           };
//         });

//         console.log("Initial auditData length:", auditData.length);

//         // Batch fetch audit details
//         const auditIds = auditData.map(audit => audit.id);
//         console.log("Total audits to fetch details for:", auditIds.length);

//         const startTime = performance.now();

//         const detailsResponse = await axios.post('/process_data/batch_check_and_get_details', {
//           auditIds
//         });

//         const endTime = performance.now();
//         console.log(`Time taken to fetch batch details: ${(endTime - startTime).toFixed(2)} ms`);

//         const fetchedDetails = detailsResponse.data.audits;

//         // Merge fetched details with auditData and handle multiple cattles
//         let auditDataWithDetails = [];
        
//         auditData.forEach(audit => {
//           const found = fetchedDetails.find(item => item.id === audit.id);
//           const noOfCattles = parseInt(audit.no_of_cattles) || 1;
          
//           if (noOfCattles > 1) {
//             // Create multiple entries for the same audit
//             for (let i = 1; i <= noOfCattles; i++) {
//               auditDataWithDetails.push({
//                 ...audit,
//                 id: `${audit.originalId}_cattle${i}`, // Suffixed ID
//                 originalAuditId: audit.originalId, // Store original audit ID for reference
//                 cattleNumber: i, // Track which cattle this represents
//                 totalCattles: noOfCattles, // Total number of cattles for this audit
//                 Make: found?.details.Make || '',
//                 Model: found?.details.Model || '',
//                 'Name of Customer': found?.details["Farmer's Name"] || ' ',
//                 'Address': found?.details["Farmer's Address"] || ' '
//               });
//             }
//           } else {
//             // Single cattle - keep original format
//             auditDataWithDetails.push({
//               ...audit,
//               id: audit.originalId, // Use original ID
//               originalAuditId: audit.originalId,
//               cattleNumber: 1,
//               totalCattles: 1,
//               Make: found?.details.Make || '',
//               Model: found?.details.Model || '',
//               'Name of Customer': found?.details["Farmer's Name"] || ' ',
//               'Address': found?.details["Farmer's Address"] || ' '
//             });
//           }
//         });

//         console.log("auditDataWithDetails after cattle mapping:", auditDataWithDetails);
//         console.log("Total entries after cattle mapping:", auditDataWithDetails.length);

//         // Compute status counts - all audits in 'new' status
//         const computedCounts = {
//           new: auditDataWithDetails.length,
//           inProgress: 0,
//           inactive: 0
//         };

//         console.log("Computed counts:", computedCounts);

//         // Update state
//         setAudits(auditDataWithDetails);
//         setCounts(computedCounts);

//         if (agentResponse.status === 200) {
//           setAgentDetails(agentResponse.data[0]);
//         } else {
//           setError('Failed to fetch agent details');
//         }
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError('An error occurred while fetching data');
//       } finally {
//         setLoadingComplete(true);
//         setLoading(false);
//       }
//     };

//     fetchAuditsAndDetails();
//   }, [userID]);

//   useEffect(() => {
//     const handleResize = () => {
//       const windowWidth = window.innerWidth
//       if (windowWidth <= 450) {
//         setDialogWidth('94vw')
//       } else if (windowWidth <= 475) {
//         setDialogWidth('94vw')
//       } else if (windowWidth <= 570) {
//       } else if (windowWidth <= 575) {
//         setDialogWidth('64vw')
//       } else if (windowWidth <= 650) {
//         setDialogWidth('60vw')
//       } else if (windowWidth <= 700) {
//       } else if (window.innerWidth <= 775) {
//         setDialogWidth('57vw')
//       } else if (window.innerWidth <= 875) {
//         setDialogWidth('55vw')
//       } else if (windowWidth <= 1000) {
//         setDialogWidth('48vw')
//       } else if (window.innerWidth <= 1100) {
//         setDialogWidth('45vw')
//       } else if (windowWidth <= 1300) {
//         setDialogWidth('40vw')
//       } else {
//         setDialogWidth('35vw')
//       }
//     }

//     window.addEventListener('resize', handleResize)
//     handleResize()
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])


 
//   const tabsRef = useRef({})



//   const tabs = ['new', 'renewal', 'claim']

//   const [swiping, setSwiping] = useState(false)




//   const handleClickOutside = event => {
//     if (popupRef.current && !popupRef.current.contains(event.target)) {
//       setIsPopupVisible(false)
//     }
//   }

//   useEffect(() => {
//     if (isPopupVisible) {
//       document.addEventListener('mousedown', handleClickOutside)
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside)
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside)
//     }
//   }, [isPopupVisible])
  
//   const handleNavigateClick = audit => {
//     console.log(userID)
//     navigate(`/auditDescription`, {
//       state: { 
//         audit, 
//         userID, 
//         agentDetails, 
//         activeTab,
//         // Pass cattle information for handling in the next screen
//         cattleNumber: audit.cattleNumber,
//         totalCattles: audit.totalCattles,
//         originalAuditId: audit.originalAuditId
//       }
//     })
//   }
  
 
// const handleAddClick = async () => {
//   try {
//     console.log('Checking audit limit for userID:', userID);

//     // Check audit limit before navigating
//     const response = await axios.post('/create_audit/check_audit_limit', {
//       userID: userID
//     });

//     console.log('Audit limit response:', response.data);

//     // ✅ FIXED: Check if limit is reached
//     if (response.data.success && response.data.hasReachedLimit) {
//       toast.error("You can't create audit now, you have reached the limit", {
//         position: 'bottom-center',
//         autoClose: 4000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         className: 'custom-toast',
//         style: {
//           background: '#fff',
//           color: '#FC350B',
//           fontWeight: 'bold',
//           border: '2px solid #FC350B'
//         }
//       });
//       return; // ✅ STOP HERE - Don't navigate
//     }

//     // If limit not reached, navigate to home
//     navigate('/home');
    
//   } catch (error) {
//     console.error('Error checking audit limit:', error);
    
//     // ✅ FIXED: Don't navigate on error - fail closed
//     toast.error('Failed to verify audit limit. Please try again.', {
//       position: 'bottom-center',
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       className: 'custom-toast',
//       style: {
//         background: '#fff',
//         color: '#FC350B',
//         fontWeight: 'bold',
//         border: '2px solid #FC350B'
//       }
//     });
//     // Don't navigate - return here
//   }
// };

//   const handleClickOpen = () => {
//     setOpen(true)
//   }

//   const handleClose = () => {
//     setOpen(false)
//   }
  
//   const handleLogout = () => {
//     navigate('/login')
//   }
 



//   const [filteredAudit, setFilteredAudit] = useState([])
//   const filteredAudits = (
//     filteredAudit.length > 0 ? filteredAudit : audits
//   ).filter(audit => {
//     return audit.status === activeTab
//   })

//   const handleSearch = query => {
//     const filtered = audits.filter(
//       audit =>
//         audit['Name of Customer'].toLowerCase().includes(query.toLowerCase()) ||
//         audit['id'].toLowerCase().includes(query.toLowerCase()) ||
//         audit['originalAuditId'].toLowerCase().includes(query.toLowerCase())
//     )
//     setFilteredAudit(filtered)
//   }

//   const [sortOrder, setSortOrder] = useState('desc')

//   const handleDateSort = () => {
//     setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'))
//   }
  
//   console.log('activeTab', activeTab)

//   return (
//     <div className='audit-list-container'>
//       <div className='header-container'>
//         <h1>Assigned Cattle Insurance</h1>
//         <img
//           src={menuIcon}
//           alt='Options'
//           className='three-dots-icon'
//           onClick={() => setIsPopupVisible(!isPopupVisible)}
//         />
//         {isPopupVisible && (
//           <div className='popup-menu' ref={popupRef}>
//             <button className='popup-item' onClick={handleClickOpen}>
//               <img src={infoIcon} alt='Info' className='info-icon' />
//               Help
//             </button>
//             <button className='popup-item' onClick={handleLogout}>
//               Logout
//             </button>
//           </div>
//         )}
//       </div>
      
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         className='support-popup-dialog'
//       >
//         <DialogContent className='support-popup-content'>
//           <Support />
//           <button onClick={handleClose} className='close-btn'>
//             close
//           </button>
//         </DialogContent>
//       </Dialog>

//           >
//             Claim <span className='count'>{counts.inactive}</span>
//           </button>
//         </div>
//       </div>

//       <div className='filters'>
//         <div className='search-container'>
//           <input
//             type='text'
//             placeholder='Search'
//             className='search-input'
//             onChange={e => handleSearch(e.target.value)}
//           />
//           <img src={searchIcon} alt='Search Icon' className='search-icon' />
//         </div>

//         {!(activeTab === 'new' || activeTab === 'inProgress') && (
//           <button className='date-filter-button' onClick={handleDateSort}>
//             Date
//             <span className='sort-icon'>
//               <img
//                 src={downArrow}
//                 alt='Sort Descending'
//                 className={`sort-arrow down-arrow ${sortOrder === 'desc' ? 'visible' : 'hidden'}`}
//               />
//               <img
//                 src={upArrow}
//                 alt='Sort Ascending'
//                 className={`sort-arrow up-arrow ${sortOrder === 'asc' ? 'visible' : 'hidden'}`}
//               />
//             </span>
//           </button>
//         )}
//       </div>

//       {!loadingComplete ? (
//         <div className='loader-container'>
//           <CircularProgress style={{ color: '#FC350B' }} size={40} />
//         </div>
//       ) : audits.length === 0 ? (
//         <div className='no-audit-message'>
//         </div>
//       ) : (
//         <div
//           {...swipeHandlers}
//           className={`audit-cards ${swiping ? 'swiping' : ''}`}
//         >
//           {
//             filteredAudits
//               .slice()
//               .sort((a, b) => {
//                 const dateA = moment(
//                   `${a.date} ${a.time}`,
//                   'DD-MM-YYYY HH:mm'
//                 ).toDate()
//                 const dateB = moment(
//                   `${b.date} ${b.time}`,
//                   'DD-MM-YYYY HH:mm'
//                 ).toDate()

//                 return sortOrder === 'asc' ? dateA - dateB : dateB - dateA
//               })
//               .map(audit => (
//                 <div className='audit-card' key={audit.id}>
//                   <div className='audit-header'>
//                     <div className='header-one'>
//                       <p className='audit-id'>
//                         {audit.id}
//                         {audit.totalCattles > 1 && (
//                           <span className='cattle-badge'> (Cattle {audit.cattleNumber} of {audit.totalCattles})</span>
//                         )}
//                       </p>
//                       <div className='date-container'>
//                         <img
//                           src={calendar}
//                           alt='Calendar Icon'
//                           className='calendar-icon'
//                         />
//                         <p>{audit.date}</p>
//                       </div>
//                     </div>
//                     <div className='header-two'>
//                       <div className='audit-tags'>
//                         {audit.mode && (
//                           <span className='audit-tag'>
//                             {audit.mode.charAt(0).toUpperCase() +
//                               audit.mode.slice(1).toLowerCase()}{' '}
//                             Mode
//                           </span>
//                         )}
//                       </div>

//                       <p>{audit.time}</p>
//                     </div>
//                   </div>
//                   <div className='audit-details'>
//                     <p>
//                      Name: {audit['Name of Customer'] || ''}
//                     </p>
//                     <p>Address : {audit['Address'] || ''}</p>
//                   </div>

//                   <div className='audit-actions'>
//                     {/* {activeTab === 'inactive' ? (
//                       audit.used === 'processed' ? (
//                         <button
//                           className='download-button'
//                           onClick={() => handleDownloadClick(audit.id)}
//                           disabled={downloading[audit.id]}
//                         >
//                           {downloading[audit.id]
//                             ? 'Downloading...'
//                             : 'Download'}
//                           <img
//                             src={downloadIcon}
//                             alt='Download Icon'
//                             className='download-icon'
//                           />
//                         </button>
//                       ) : audit.used === 'processing' ? (
//                         <button className='expired-button' disabled>
//                           Used
//                         </button>
//                       ) : (
//                         <button className='expired-button' disabled>
//                           Expired
//                         </button>
//                       )
//                     ) : (
//                       <button
//                         className='share-button'
//                         onClick={() => handleShareClick(audit)}
//                       >
//                         <img
//                           src={share}
//                           alt='Share Icon'
//                           className='share-icon'
//                         />
//                         Share
//                       </button>
//                     )} */}

//                     <button
//                       className='navigate-button'
//                       onClick={() => handleNavigateClick(audit)}
//                     >
//                       {activeTab === 'inactive' ? 'More Info' : 'Start'}
//                       <img src={next} alt='next Icon' className='next-icon' />
//                     </button>
//                   </div>
//                 </div>
//               ))
//           }
//         </div>
//       )}
//       <button className='fab' onClick={() => handleAddClick()}>
//         +
//       </button>
      
//       <ToastContainer />
//     </div>
//   )
// }

// export default AuditList;